module.exports = __webpack_public_path__ + "static/NHaasGroteskDSStd-95Blk-649bef1f4283ea2fbda709acbc68ae20.woff2";